export var CaseVoucherTags;
(function (CaseVoucherTags) {
    CaseVoucherTags["IMPOSEDBYCOLLECTOR"] = "IMPOSEDBYCOLLECTOR";
    CaseVoucherTags["IMPOSEDBYCREDITOR"] = "IMPOSEDBYCREDITOR";
    CaseVoucherTags["CREDITORTRANSACTION"] = "CREDITORTRANSACTION";
    CaseVoucherTags["ECONOMIC_IMPORT"] = "ECONOMIC_IMPORT";
    CaseVoucherTags["EXPIRED"] = "EXPIRED";
    CaseVoucherTags["IRRECOVERABLE"] = "IRRECOVERABLE";
})(CaseVoucherTags || (CaseVoucherTags = {}));
//# sourceMappingURL=index.js.map